<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useCustomerStore } from '@/stores/customer';

const props = defineProps({
    customer: {
        type: Object,
        default: () => ({
            first_name: '',
            last_name: '',
            company_name: '',
            is_company: false,
            email: '',
            phone: '',
            is_active: true,
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const emit = defineEmits(['close-modal', 'cancel-modal']);

const form = ref({
    is_company: props.customer.is_company,
    first_name: props.customer.first_name,
    last_name: props.customer.last_name,
    company_name: props.customer.company_name,
    email: props.customer.email,
    phone: props.customer.phone,
    is_active: props.customer.is_active,
});

const { storeCustomer, updateCustomer } = useCustomerStore();

const save = async () => {
    try {
        if (props.mode === 'Create') {
            await storeCustomer(form.value);
        } else {
            await updateCustomer({
                ...form.value,
                hash: props.customer.hash,
            });
        }

        emit('close-modal');
    } catch (error) {
        // The response interceptor surfaces the error toast
    }
};
</script>
<template>
<ModalWrapper @cancel-modal="emit('cancel-modal')">
    <template #header>{{ mode }} {{ $t('label.customer') }}</template>
    <template #subheader>{{ $t('label.create_or_edit', { what: $t('label.customer') }) }}</template>

    <form @submit.prevent="save">
        <StyledRoundSwitch
            v-model="form.is_company"
            :label="$t('label.company')"
            inset
            name="is_company" />

        <div class="grid md:grid-cols-2 gap-x-4 gap-y-3 mt-3">
            <template v-if="!form.is_company">
                <StyledInput
                    v-model="form.first_name"
                    name="first_name"
                    :placeholder="$t('label.first_name')"
                    :label="$t('label.first_name')" />
                <StyledInput
                    v-model="form.last_name"
                    name="last_name"
                    :placeholder="$t('label.last_name')"
                    :label="$t('label.last_name')" />
            </template>
            <StyledInput
                v-else
                v-model="form.company_name"
                name="company_name"
                class="md:col-span-2"
                :placeholder="$t('label.company_name')"
                :label="$t('label.company_name')" />
            <StyledInput
                v-model="form.email"
                name="email"
                :placeholder="$t('label.email')"
                :label="$t('label.email')" />
            <StyledInput
                v-model="form.phone"
                name="phone"
                :placeholder="$t('label.phone')"
                :label="$t('label.phone')" />
        </div>

        <StyledRoundSwitch
            v-if="mode === 'Edit'"
            v-model="form.is_active"
            :label="$t('label.active')"
            inset
            class="mt-2"
            name="is_active" />
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
